
import {computed, defineComponent, onMounted, PropType, reactive, ref, toRefs, watch} from 'vue'
import {RequestHandler} from '@Protium/vue-ozone-utils'
import {CtCatalogue, CtCatalogueProduct, CtProduct} from '@/models/interfaces/content-type'
import {SkuController, SkuCtrl} from '@/pages/Manage/Catalogues/utils'
import PenIcon from '@/components/Icons/PenIcon.vue'
import ToggleNew from '@/components/ToggleNew.vue'

export default defineComponent({
  name: 'ProductCardVariant',
  components: {PenIcon, ToggleNew},
  props: {
    catalogue: {
      type: Object as PropType<CtCatalogue>
    },
    catalogueVariant: { // the catalogue-product entry, if it exists
      type: Object as PropType<CtCatalogueProduct>
    },
    product: {
      type: Object as PropType<CtProduct>,
    },
    editing: {
      type: Boolean,
    }
  },
  emits: ['update:catalogueVariant', 'add-variant', 'update:editing'],
  setup (props, {emit}) {
    const skuController = ref<SkuCtrl>(SkuController(props.catalogue))
    watch(() => props.catalogue, c => {
      skuController.value = SkuController(c)
    })

    const state = reactive({
      triggerActivate: false,
      shouldActivate: !props.catalogueVariant
    })

    function emitAdd (value) {
      if (state.shouldActivate && value === true) {
        state.shouldActivate = false
        startEditing()
        emit('add-variant', props.product, props.catalogueVariant?.sys.id)
      }
    }

    function init () {
      props.editing && !props.catalogueVariant && emitAdd(true)
    }

    onMounted(init)

    const variantIds = computed(() => {
      const sku = props.catalogueVariant?.sku ? skuController.value.display(props.catalogueVariant?.sku) : null
      const ean = (props.product?.ean || []).join(', ')
      if (sku && ean) {
        return `${sku}\xA0—\xA0${ean}`
      }
      return sku ?? ean
    })

    const variantPrice = computed(
      () => props.catalogueVariant?.price ? `€\xA0${props.catalogueVariant.price}` : null
    )

    const startEditing = () => !props.editing && emit('update:editing', true)

    return {
      ...toRefs(state),
      startEditing,
      variantIds,
      variantPrice,
      skuController,
      emitAdd,
      toggleActive: (active: boolean) => {
        startEditing()
        emit('update:catalogueVariant', { ...props.catalogueVariant, active, sys: { ...(props.catalogueVariant?.sys || {}), editing: true } })
      },
      updatePrice: (price: string | number | null) => {
        emit('update:catalogueVariant', { ...props.catalogueVariant, price, sys: { ...(props.catalogueVariant?.sys || {}), editing: true } })
      },
      updateTitle: (title: string) => {
        emit('update:catalogueVariant', { ...props.catalogueVariant, title, sys: { ...(props.catalogueVariant?.sys || {}), editing: true } })
      }
    }
  }
})
